module.exports = __webpack_public_path__ + "img/4.f73f5238.png";